###
  * Make a light slider that fade from one image to the next
  * @package Syltaen
  * @author Stanley Lambot
  * @requires jQuery
###

import $ from "jquery"

# ==================================================
# > CLASSES
# ==================================================
###
  * @param {*} $el The slide wrapper
  * @param int speed The speed to use
###
class LightSlide

    constructor: (@$el, @speed) ->
        @$slides  = @$el.find("li")
        @current  = 0
        @max      = @$slides.length

        @interval = @start()

    start: ->
        setInterval =>
            @current++
            if @current >= @max then @current = 0

            @$slides.removeClass "current"
            @$slides.eq(@current).addClass "current"

        , @speed


# ==================================================
# > JQUERY METHODS
# ==================================================
###
  * Create a light slide for each matching elements
  * @param speed The animation speed
###
$.fn.lightSlide = (speed = 5000) ->

    $(this).each ->
        new LightSlide $(this), speed

    return $(this)



// WEBPACK FOOTER //
// ./scripts/tools/lightSlide.coffee